import { Events, UnityBridge } from "@Context/common/general/context";
import { Button } from "@mui/material";
import { isFunction } from "lodash-es";

export default ({ onClick = () => {}, ...props }) => {
  const onClickSound = () => {
    Events.audio.playSound.emit({ src: "button_press", volume: 1 });

    if (isFunction(onClick)) {
      onClick();
    }
    haptics();
  };

  const haptics = () => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.TriggerHaptics,
      payload: {
        frequency: 0.25,
        amplitude: 0.1,
        duration: 0.15,
      },
    });
  };

  return <Button {...props} onClick={onClickSound} onMouseEnter={haptics} />;
};
